(function($){
	$(document).ready(function(){

		$('.product-card__attention').each((index, card)=> {
			$(card).find('.product-card__attention-read-more').on('click', function() {
				$(card).find('.product-card__attention-text').toggleClass('product-card__attention-text--open');

				if ($(card).find('.product-card__attention-text').hasClass('product-card__attention-text--open')) {
					$(this).text('Свернуть');
				} else {
					$(this).text('Читать далее');
				}
			});
		});
	});
// eslint-disable-next-line no-undef
})(jQuery);
